import SEO from '@/components/SEO';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, ArrowRight } from 'lucide-react';

const locations = [
  {
    name: 'UK Repair Centre',
    address: ['Unit 9, West Moor Park', 'Yorkshire Way', 'Doncaster, DN3 3GW'],
    phone: '0333 006 4326',
    phoneHref: 'tel:+443330064326',
    hours: 'Mon \u2013 Fri / 9:00 \u2013 17:00',
  },
  {
    name: 'Ireland Repair Centre',
    address: ['Unit 7b, Universal Business Park', 'Bluebell, Dublin, D12'],
    phone: '+353 1 582 7344',
    phoneHref: 'tel:+35315827344',
    hours: 'Mon \u2013 Fri / 9:00 \u2013 17:00',
  },
];

export default function ContactPage() {
  return (
    <>
      <SEO
        title="Contact Us | Projector Repair London"
        description="Contact Projector Repair London. UK Repair Centre in Doncaster and Ireland Repair Centre in Dublin. Call 0333 006 4326 or +353 1 582 7344."
        canonical="https://projectorrepairlondon.co.uk/contact"
      />

      {/* Hero - DARK */}
      <section className="bg-[#0057B7] pt-32 pb-16 md:pt-40 md:pb-24">
        <div className="container-custom">
          <nav className="mb-6">
            <ol className="flex items-center gap-2 text-sm">
              <li><Link to="/" className="text-white/40 hover:text-white transition-colors">Home</Link></li>
              <li className="text-white/20">/</li>
              <li className="text-white font-medium">Contact Us</li>
            </ol>
          </nav>
          <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold text-white max-w-2xl leading-tight">
            Contact <span className="text-[#FFDD00]">Projector Repair London</span>
          </h1>
          <p className="mt-4 text-white/50 max-w-xl leading-relaxed">
            Have a question about your projector repair? Get in touch with our team. We have repair centres in the UK and Ireland.
          </p>
        </div>
      </section>

      {/* Contact Cards - CREAM */}
      <section className="bg-[#E8F0FE] py-12 lg:py-16">
        <div className="container-custom">
          <div className="text-center max-w-2xl mx-auto mb-10">
            <span className="font-label text-[#0057B7]">Our Locations</span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-[#0057B7] mt-2">Repair Centres</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            {locations.map((loc) => (
              <div key={loc.name} className="bg-white rounded-xl p-8 border border-[#0057B7]/5">
                <h3 className="font-heading font-semibold text-xl text-[#0057B7] mb-5">{loc.name}</h3>
                <ul className="space-y-4">
                  <li className="flex items-start gap-3 text-sm text-[#0057B7]/70">
                    <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-[#0057B7]" />
                    <span>{loc.address[0]}<br />{loc.address[1]}<br />{loc.address[2]}</span>
                  </li>
                  <li>
                    <a href={loc.phoneHref} className="flex items-start gap-3 text-sm text-[#0057B7]/70 hover:text-[#0057B7] transition-colors">
                      <Phone className="w-4 h-4 mt-0.5 shrink-0 text-[#0057B7]" />
                      <span className="font-semibold">{loc.phone}</span>
                    </a>
                  </li>
                  <li className="flex items-start gap-3 text-sm text-[#0057B7]/70">
                    <Clock className="w-4 h-4 mt-0.5 shrink-0 text-[#0057B7]" />
                    <span>{loc.hours}</span>
                  </li>
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Email - WHITE */}
      <section className="bg-white py-12 lg:py-16">
        <div className="container-custom">
          <div className="text-center max-w-2xl mx-auto mb-10">
            <span className="font-label text-[#0057B7]">Email</span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-[#0057B7] mt-2">Send Us a Message</h2>
          </div>
          <div className="max-w-xl mx-auto bg-[#E8F0FE] rounded-xl p-8 border border-[#0057B7]/5 text-center">
            <Mail className="w-10 h-10 text-[#0057B7] mx-auto mb-4" />
            <p className="text-[#0057B7]/70 text-sm mb-3">For general enquiries, warranty claims, and support:</p>
            <a href="mailto:wellselectronicsltd@gmail.com" className="text-lg font-semibold text-[#0057B7] hover:text-[#0057B7] transition-colors">
              wellselectronicsltd@gmail.com
            </a>
          </div>
        </div>
      </section>

      {/* CTA - GOLD */}
      <section className="bg-[#FFDD00] py-16">
        <div className="container-custom text-center">
          <h2 className="font-heading text-3xl font-bold text-[#0057B7]">Ready to Get Your Projector Fixed?</h2>
          <p className="mt-4 text-[#0057B7]/70 max-w-lg mx-auto">Submit a repair enquiry and our team will arrange free collection and diagnostic assessment.</p>
          <div className="mt-8">
            <Link to="/repair-enquiry" className="inline-flex items-center gap-2 px-8 py-4 bg-[#0057B7] text-[#FFDD00] rounded-lg font-bold hover:bg-white/90 transition-all text-lg">
              Repair Enquiry <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
